import axios from 'axios';
import { BaseURL } from './config';

const api = axios.create({
  baseURL: BaseURL
});

const googleRecaptchaConfig = {
  sitekey: "6Lfm4ZYUAAAAADF_o44jz2uoYkAwHuB2_LexPfYP"
};

export { 
  api,
  googleRecaptchaConfig,
};

